import { FormDetail } from './form-detail';
export { FormDetail, };
